import { atomWithQuery } from 'jotai-tanstack-query';
import { SundVaegtProgramDto } from '@/shared/interfaces/api/sundvaegt-interfaces';
import { getOrCreateSundVaegtProgram } from '../api/getOrCreateSundVaegtProgram';

export const fetchSundVaegtProgramQueryAtom = atomWithQuery<
    SundVaegtProgramDto | undefined
>(() => ({
    queryKey: ['sundvaegt-weightprogram'],
    queryFn: async () => {
        return getOrCreateSundVaegtProgram();
    },
    initialData: undefined,
    enabled: true,
}));
